module.exports = __webpack_public_path__ + "img/suitable_small.90c2c1a9.svg";